import mqtt from "precompiled-mqtt";

const { MQTT } = require('../config')

class Mqtt {
  /**
   *
   * @param mqttStorage - MqttStorage
   */
  constructor(mqttStorage) {
    // Create storage for mqttStorage
    this.mqttStorage = mqttStorage;
  }

  /**
   * Connect this MQTT client to the Broker.
   */
  connect() {
    console.log(new Date().toISOString(), 'INFO', 'MQTT', `Connecting to MQTT broker ${MQTT.HOST}...`);
    this.client = mqtt.connect(MQTT.HOST, MQTT.OPTIONS);

    this.client.on('connect', () => {
      console.log(new Date().toISOString(), 'INFO', 'MQTT', `Connected to MQTT broker ${MQTT.HOST}`);

      this.client.subscribe('#', (err) => {
        if(err) {
          console.log(new Date().toISOString(), 'WARN', 'MQTT', 'Error subscribing to "#" :', err);
        }
        else {
          console.log(new Date().toISOString(), 'INFO', 'MQTT', 'Subscribed to "#" ');
        }
      });
    });

    this.client.on('error', (err) => {
      console.error(new Date().toISOString(), 'ERROR', 'MQTT', err);
    });

    this.client.on('disconnect', () => {
      console.warn(new Date().toISOString(), 'WARN', 'MQTT', 'Disconnected. Reconnecting...');
      this.client.reconnect();
    });

    this.client.on('offline', () => {
      console.warn(new Date().toISOString(), 'WARN', 'MQTT', 'Client went offline. Shutting down Rest2Mqtt');
      // TODO Reconnect... process.exit(1);
    })

    this.client.on('message', (topic, message, packet) => {
      const messageStr = message.toString();  // message is Buffer

      console.log(`Received MQTT message on topic "${topic}": `, messageStr)
      this.mqttStorage.setItem(topic, messageStr);      // Store topic / message
    })
  }

  /**
   * Publish message under topic. Use options from MQTT.OPTIONS:
   *  - qos: default: 2
   * @param topic string
   * @param message string
   * @param callback - function (err), fired when the QoS handling completes, or at the next tick if QoS 0. An error occurs if client is disconnecting.
   */
  publish(topic, message, callback) {
    const options = {
      qos: 2,
    }
    this.client.publish(topic, message, options, () => {
      console.log(new Date().toISOString(), 'INFO', 'MQTT', `Published to MQTT broker: ${topic} > ${message}`);
      // TODO add callback for error handling
    });
  }
}

export default Mqtt;
